export default __webpack_public_path__ + "hall-of-fame-mobile-14be6c014f3713b27a449d25ba17cd1b.png";